<!-- <div style="width: fit-content; margin: 20px auto;">
  <app-search />
</div> -->
<div style="
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
">
  <div style="
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    background: #f9fafb;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    transition: all 0.2s ease;
  ">

    <input type="checkbox" id="showMyRequestsOnly" [checked]="showMyRequestsOnly"
      (change)="onShowMyRequestsOnlyChange($event)" style="
        width: 16px;
        height: 16px;
        cursor: pointer;
        accent-color: #0f4c81;
      " />

    <label for="showMyRequestsOnly" style="
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        color: #374151;
        user-select: none;
      ">
      Show My Requests Only
    </label>

  </div>
</div>
<mat-paginator [length]="this.pagedParamsService.pagedParams().totalCount"
  [pageSize]="this.pagedParamsService.pagedParams().pageSize"
  [pageIndex]="this.pagedParamsService.pagedParams().pageNumber-1" [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000]"
  [showFirstLastButtons]="true" (page)="onPageChange($event)"
  style="margin: 20px auto; width: fit-content; background-color: #fff;"></mat-paginator>

<div class="table-container">
  <table [class]="busyService.loading ? 'table collapse': 'table expand'">
    <thead>
      <tr class="table-row">
        <th [width]="45">Req ID</th>
        <th [width]="120">REQ DATE</th>
        <th [width]="140">REQ BY</th>
        <th [width]="140">EQUIPMENT</th>
        <th [width]="100">LOCATION</th>
        <th [width]="170">DESCRIPTION</th>
        <th [width]="140">ASSIGNED TO</th>
        <th [width]="60">TAGGED<br />OUT</th>
        <th [width]="60">LOTO<br />FOLLOWED</th>
        <th [width]="80">STATUS</th>
      </tr>
    </thead>
    <tbody>
      @for (request of maintenanceRequests; track $index) {
      <tr class="table-row" style="height: 60px;">
        <td>
          <a [routerLink]="['/maintenance-request', request.id]">
            <span class="link-text">{{ request.id }}</span>
          </a>
        </td>
        <td>{{ dateFormatter(request.createdAt) }}</td>
        <td>{{ request.createdBy.firstName }} {{ request.createdBy.lastName }}</td>
        <td>
          @if( request.equipmentMachine) {
          {{ request.equipmentMachine.name }} ({{ request.equipmentMachine.id }})
          } @else {
          N/A
          }

        </td>
        <td>
          @if( request.location) {
          {{ request.location.name }} ({{ request.location.id }})
          } @else {
          N/A
          }
        </td>
        <td style="
          max-width:250px;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        ">{{ request.description }}</td>
        <td>
          @if( request.assignedTo) {
          {{ request.assignedTo.firstName }} {{ request.assignedTo.lastName }}
          } @else {
          N/A
          }
        </td>
        <td>
          @if( request.isTaggedOut === null) {
          N/A
          } @else if( request.isTaggedOut) {
          Yes
          } @else {
          No
          }
        </td>
        <td>
          @if( request.isLOTOFollowed === null) {
          N/A
          } @else if( request.isLOTOFollowed) {
          Yes
          } @else {
          No
          }
        </td>
        <td>{{ request.status }}</td>

      </tr>
      }
    </tbody>
  </table>
</div>
<!--
<mat-menu #sortMenu="matMenu">
  <mat-selection-list [multiple]="false" (selectionChange)="onSortChange($event)">
    @for (sortOption of sortOptions; track $index) {
    <mat-list-option [value]="sortOption.value" [selected]="selectedSort === sortOption.value">
      {{ sortOption.label }}
    </mat-list-option>
    }
  </mat-selection-list>
</mat-menu>
<mat-menu #sortMenu="matMenu">
  <mat-selection-list [multiple]="false" (selectionChange)="onSortChange($event)">
    @for (sortOption of sortOptions; track $index) {
    <mat-list-option [value]="sortOption.value" [selected]="selectedSort === sortOption.value">
      {{ sortOption.label }}
    </mat-list-option>
    }
  </mat-selection-list>
</mat-menu> -->